<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title">
        <el-input v-model="keywordData.name_keyword"></el-input>
      </el-form-item>
      <el-form-item label="院校" class="college">
        <el-autocomplete
          v-model="selectedUniversity.chinese_name"
          :fetch-suggestions="searchUniversity"
          @select="handleSelect"
          placeholder="选择院校"
        >
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="职称" class="tag">
        <el-select
          v-model="keywordData.title_id"
          clearable
          placeholder="职称"
          class="tag"
        >
          <el-option
            v-for="(item, index) in titleList"
            :key="index"
            :label="item.english_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <br />
      <el-form-item label="标签" class="keyword">
        <keywordsinput
          :maxLen="18"
          v-model="keywordData.tags_keywords"
        ></keywordsinput>
      </el-form-item>
      <el-form-item label="WUPEN联盟" class="is-wupen">
        <el-select
          v-model="keywordData.wupen_flag"
          lable="联盟"
          clearable
          placeholder="联盟"
        >
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="状态" clearable placeholder="状态" class="status">
        <el-select v-model="keywordData.status" clearable placeholder="状态">
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
import {
  scholarUniversityDropDown_Api,
  ScholarTitleTopics_Api,
} from "@/apis/scholar.api";
export default {
  data() {
    return {
      keywordData: {
        id: null,
        name_keyword: "",
        tags_keywords: [],
        wupen_flag: "",
        university_id: null,
        title_id: null,
        status: null,
      },
      selectedUniversity: { chinese_name: "" },
      universityList: [],
      titleList: [],
    };
  },
  mounted() {
    // 职称下拉列表
    this.getTitleScholarTitleList();
  },
  methods: {
    searchUniversity(queryString, callback) {
      scholarUniversityDropDown_Api(queryString).then((res) => {
        for (let i of res.data) {
          i.value = i.chinese_name;
        }
        this.universityList = res.data;
        callback(this.universityList);
      });
    },
    handleSelect(item) {
      this.selectedUniversity = item;
    },

    getTitleScholarTitleList() {
      ScholarTitleTopics_Api().then((res) => {
        this.titleList = res.data;
        console.log(this.titleList);
      });
    },
    search() {
      if (!this.selectedUniversity.chinese_name) {
        this.keywordData.university_id = null;
      } else {
        this.keywordData.university_id = this.selectedUniversity.id;
      }
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .college {
    width: 300px;
  }
  .title {
    width: 400px;
  }
  .is-wupen {
    width: 200px;
    margin-right: 110px;
  }
  .tag {
    width: 300px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .status {
    width: 200px;
  }
  .keyword {
    width: 400px;
    height: 40px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/scholar/components/ScholarSearch.vue